import { serverApi } from "./serverApi";
import { ErrorType } from "../types/sharedTypes";
import { TestCase } from "../types/testCaseTemplateTypes";

export const requestService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    createTestCase: build.mutation<number, TestCase>({
      query: (request) => ({
        url: "/requests/request",
        method: "POST",
        body: request
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    updateTestCase: build.mutation<string, TestCase>({
      query: (request) => ({
        url: "/requests/request",
        method: "PUT",
        body: request
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    deleteTestCase: build.mutation<string, number>({
      query: (testCaseId) => ({
        url: "/requests/request",
        method: "DELETE",
        params: { id: testCaseId }
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
  })
});

export const {
  useCreateTestCaseMutation,
  useUpdateTestCaseMutation,
  useDeleteTestCaseMutation
} = requestService;